import React from 'react';
import wb0 from '../img/Detail/requiem_detail.jpg';
import './Detail.css';
const RequiemDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default RequiemDetail;